import React from 'react';
import { useTranslation } from 'utils/modifiedTranslation';
import app from 'new-ui/app';
import { PAGES, POPUP_TYPES, ROUTES } from 'new-ui/constants';
import SaveSearchPopup from 'new-ui/Search/SaveSearch';
import ProfileButton from 'new-ui/Components/ProfileButton';
import SearchIcon from 'new-ui/assets/icons/search-zoom-in.svg';
import styles from './headerRightSlot.module.css';

export const HeaderRightSlot = () => {
  const { t } = useTranslation();
  const handleNewClick = () => {
    app.setPopup(POPUP_TYPES.GENERAL, {
      theme: 'middle',
      title: t('save_profile.title'),
      content: (
        <SaveSearchPopup
          handleContinueWithoutSaving={() => {
            app.setPopup(false);
            app.history.push(`${ROUTES[PAGES.SEARCH]}?new=1`);
          }}
          handleSaveAndContinue={() => {
            app.setPopup(false);
            app.history.push(`${ROUTES[PAGES.SEARCH]}?save=1`);
          }}
        />
      ),
    });
  };

  return (
    <div className={styles.root}>
      <button
        type="button"
        onClick={handleNewClick}
        className={styles.newButton}
      >
        <img src={SearchIcon} alt="icon" />
        <span className={styles.newButtonLabel}>
          New
        </span>
      </button>
      <div className={styles.profileButtonWrapper}>
        <ProfileButton />
      </div>
    </div>
  );
};
